<template>
  <span class="svg-icon-box">
    <svg v-if="isTwoTone" :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 3H16.1C17.9 3 18.8 3.9 18.8 5.7V6.942" :fill="color"/>
      <path d="M8 3H16.1C17.9 3 18.8 3.9 18.8 5.7V6.942L8 3Z" :stroke="color" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M21 11.1V16.5C21 20.1 20.1 21 16.5 21H7.5C3.9 21 3 20.1 3 16.5V7.5C3 3.9 3.9 3 7.5 3H8.85C10.2 3 10.497 3.396 11.01 4.08L12.36 5.88C12.702 6.33 12.9 6.6 13.8 6.6H16.5C20.1 6.6 21 7.5 21 11.1Z" :fill="color2" :stroke="color2" stroke-width="1.5" stroke-miterlimit="10"/>
      <path d="M15.5825 19.89C13.4725 20.04 13.4725 23.1 15.5825 23.25H20.5925C21.2025 23.25 21.7825 23.03 22.2325 22.62C23.7125 21.33 22.9225 18.73 20.9725 18.49C20.2725 14.27 14.1625 15.87 15.6125 19.89" :fill="color"/>
    </svg>
    <svg v-else :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M21 11.1V16.5C21 20.1 20.1 21 16.5 21H7.5C3.9 21 3 20.1 3 16.5V7.5C3 3.9 3.9 3 7.5 3H8.85C10.2 3 10.497 3.396 11.01 4.08L12.36 5.88C12.702 6.33 12.9 6.6 13.8 6.6H16.5C20.1 6.6 21 7.5 21 11.1Z" :stroke="color" stroke-width="1.5" stroke-miterlimit="10"/>
      <path d="M8.40002 3H16.5C18.3 3 19.2 3.9 19.2 5.7V6.942" :stroke="color" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this.$store.state.color['coolGrey-500'] } },
    color2: { type: String, default: '#E0E3E6' },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean },
  }
}
</script>